var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsSns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7279 40.1119L15.5786 38.9591L11.6542 34.5226L16.563 34.3883L19.7279 40.1119ZM10.133 37.1862L7.79802 36.5379L5.59131 34.0426L8.2727 33.6055L10.133 37.1862Z",
    fill: "#995B80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20752 33.7291L6.59412 34.2101L6.94055 33.606V13.1066L6.59412 12.708L4.20752 14.0554V33.7291Z",
    fill: "#7B3F65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8129 14.8503L6.59473 12.708V34.21L7.97576 34.0827L10.1332 37.1864L11.7971 33.7307L15.8129 33.3606V14.8503Z",
    fill: "#C17B9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53784 34.8365L13.629 35.6535L13.8984 35.024V9.82867L13.629 9.2583L9.53784 11.3138V34.8365Z",
    fill: "#7B3F65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9726 16.688L13.6289 9.2583V35.6541L16.3321 35.3092L19.7279 40.1121L22.4162 34.533L36.9726 32.6759V16.688Z",
    fill: "#C17B9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 43.9187L26.8532 42.2808L21.2793 35.9781L28.5052 35.9053L32.75 43.9187Z",
    fill: "#995B80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2708 36.5198L24.2875 37.6741L24.7548 37.2747V4.64266L24.2875 4.00195L18.2708 6.98342V36.5198Z",
    fill: "#7B3F65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3922 13.9671L24.2881 4.00195V37.6741L27.8352 36.9694L32.7501 43.9185L36.9728 35.1554L36.9701 35.1551L44.3922 33.6809V13.9671Z",
    fill: "#C17B9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSns);
export default __webpack_public_path__ + "static/media/AwsSns.04108679.svg";
export { ForwardRef as ReactComponent };